"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("lodash/bind"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ssrWindow = require("ssr-window");
var _checkmarkCircleFilled = _interopRequireDefault(require("@spothero/icons/checkmark-circle-filled"));
var _exclamationCircleFilled = _interopRequireDefault(require("@spothero/icons/exclamation-circle-filled"));
var _exclamationTriangleFilled = _interopRequireDefault(require("@spothero/icons/exclamation-triangle-filled"));
var _heroCar = _interopRequireDefault(require("@spothero/icons/hero-car"));
var _x = _interopRequireDefault(require("@spothero/icons/x"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _Button = _interopRequireDefault(require("../v1/components/Button/Button"));
var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Notification extends _react.Component {
  static defaultProps = {
    type: 'info',
    duration: 3000,
    showClose: true,
    autoClose: true
  };
  constructor(props) {
    super(props);
    const {
      duration,
      autoClose
    } = props;
    if (autoClose) {
      this._hideTimeout = _ssrWindow.window.setTimeout((0, _bind.default)(this._hide, this), duration);
    }
  }
  componentDidMount() {
    _ssrWindow.window.setTimeout(() => {
      _dom.default.addClass(this._notification, 'Notification-showing');
    }, 100);
  }
  _onHideClick = evt => {
    this._hide();
  };
  _hide() {
    const {
      onHidden,
      onRemove
    } = this.props;
    if (this._hideTimeout) {
      _ssrWindow.window.clearTimeout(this._hideTimeout);
    }
    _dom.default.removeClass(this._notification, 'Notification-showing');
    _ssrWindow.window.setTimeout(() => {
      _dom.default.removeClass(this._notification, 'Notification-showing');
      if (onHidden) {
        onHidden(this.props);
      }
      onRemove();
    }, 500);
  }
  _renderIcon() {
    const {
      type
    } = this.props;
    switch (type) {
      case 'success':
        return /*#__PURE__*/_react.default.createElement(_checkmarkCircleFilled.default, null);
      case 'warning':
        return /*#__PURE__*/_react.default.createElement(_exclamationTriangleFilled.default, null);
      case 'error':
        return /*#__PURE__*/_react.default.createElement(_exclamationCircleFilled.default, null);
      case 'info':
      default:
        return /*#__PURE__*/_react.default.createElement(_heroCar.default, null);
    }
  }
  render() {
    const {
      className,
      type,
      message,
      showClose
    } = this.props;
    const classes = (0, _classnames.default)('Notification', `Notification-${type}`, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      ref: node => {
        this._notification = node;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Notification-content-container container"
    }, this._renderIcon(), /*#__PURE__*/_react.default.createElement("div", {
      className: "Notification-content"
    }, message), showClose && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Notification-hide",
      onClick: this._onHideClick
    }, /*#__PURE__*/_react.default.createElement(_x.default, {
      className: "Icon-cancel"
    }))));
  }
}
exports.default = Notification;